import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { HighlightAmenitiesViewModel, PropertyInfoSectionViewModel } from 'models';

import { ToolbarType, UitkToolbar } from 'uitk-react-toolbar';
import { UitkFullscreenDialog } from 'uitk-react-dialog';

import { addIcon } from 'utils/amenity-mapper';

import { AmenitiesList } from 'components/infosite/amenities/amenities-list';
import { AmenityDescription } from 'components/infosite/amenities/amenity-description';

export interface AmenitiesDialogProps extends LocalizedComponentProps {
  onDismiss?: () => void;
  analytics?: AnalyticsStore;
  currentHotel?: CurrentHotelStore;
  highlightAmenities?: HighlightAmenitiesViewModel[];
  propertyAmenities?: PropertyInfoSectionViewModel;
}

@withLocalization
@inject('currentHotel', 'analytics')
@observer
export class AmenitiesDialog extends React.Component<AmenitiesDialogProps> {
  public constructor(props) {
    super(props);
  }

  public render() {
    const { highlightAmenities, propertyAmenities, l10n } = this.props;
    const renderPropertyAmenities =
      propertyAmenities && propertyAmenities.title && propertyAmenities.sections && propertyAmenities.sections.length > 0;

    const toolBarAttributes = {
      type: ToolbarType.CLOSE,
      header: l10n.formatText('hotels.infosite.amenities.propertyAmenities.title'),
      iconLabel: l10n.formatText('hotels.infosite.amenities.cancelButton.a11yLabel')
    };

    const toolbarAnalytics = this.props.analytics.setupTracker('AmenitiesDialog', 'close amenities list');

    const dialogProps = {
      dialogShow: true,
      className: 'amenities-dialog'
    };

    return (
      <UitkFullscreenDialog {...dialogProps}>
        <UitkToolbar {...toolBarAttributes} analytics={toolbarAnalytics} action={this.props.onDismiss} />

        <section
          tabIndex={0}
          className="amenities-dialog__main all-t-padding-three all-y-margin-one all-x-margin-one"
          data-stid="amenities-dialog-main-section"
        >
          {highlightAmenities &&
            highlightAmenities.length > 0 &&
            highlightAmenities.map((amenity, index) => {
              const highlightSections = amenity && amenity.sections;
              if (highlightSections && highlightSections.length > 0) {
                return (
                  <div className="all-y-padding-three all-x-padding-three pwa-theme--grey-700" key={index}>
                    <AmenitiesList amenities={highlightSections.map(addIcon)} title={amenity.title} />
                  </div>
                );
              }

              return null;
            })}
          {renderPropertyAmenities && (
            <section className="amenities-property policies__card" data-stid="section-property-amenities">
              <div className="all-x-padding-three">
                {propertyAmenities.sections.map(
                  (section, index) =>
                    section.title &&
                    ((section.body && section.body.length > 0) || (section.descriptions && section.descriptions.length > 0)) && (
                      <AmenityDescription
                        key={`amenity-description__property-${index}`}
                        section={section}
                        index={index}
                        category="property"
                      />
                    )
                )}
              </div>
            </section>
          )}
        </section>
      </UitkFullscreenDialog>
    );
  }
}
